<template>
  <baidu-map>
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    <bm-view class="map">
    </bm-view>
    <bm-driving
      start="井岸"
      end="珠海健帆生物科技股份有限公司"
      startCity="珠海"
      endCity="珠海"
      :auto-viewport="true"
      :panel="false"
      location="珠海"
      :waypoints="[{lng:113.54805994480798,lat:22.33699875639315}]"
      @searchcomplete="searchcomplete"
    >
    </bm-driving>
  </baidu-map>
</template>

<script src="https://unpkg.com/vue-baidu-map"></script>
<script>

function initData() {
  return {
    pickerText: '开始时间',
    show: false,
    isDisabled: true,
    showPicker: false,
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: ''
  }
}

export default {
  data() {
    return {}
  },
  mounted () {},
  methods: {
    markersset (poism, transfers) {
        console.log('markersset')
    },
    searchcomplete(results) {
        console.log(results)
    }
  }
}
</script>

<style scoped lang="less">
  .map {
    width: 100%;
    height: 300px;
  }
</style>